<div class="flex flex-wrap">
  <div *ngFor="let template of templates$ | async" (click)="selectGrid(template.id)" class="w-64 mx-2 my-4 flex flex-col flex-wrap justify-center items-center transition ease-in-out duration-300 cursor-pointer border-2 border-transparent hover:border-blue-300 hover:shadow-lg">
    <img [src]="template.image" alt="" class="mt-2"/>
    <p class="m-2 h-auto">{{ template.description }}</p>
    <app-button name="Selecteer werkblad" classes="mx-auto my-2"></app-button>
  </div>
</div>
